import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { Title } from "../../components/NewTitle";

export const TableCell = (props) => {
  const { title, contents, isMobile } = props;

  return (
    <div className="table-cell-warp">
      {!isMobile ? <div className="cell-title">{title}</div> : ""}
      <div>
        {isMobile ? <div className="cell-title-mobile">{title}</div> : ""}
        {contents.map((item) => {
          return (
            <div className="cell-content-warp">
              <div className="cell-subtitle-warp">
                <div className="cell-subtitle">{item.subtitle}</div>
              </div>
              <div className="cell-descript-warp">
                {item.descriptions.map((description) => {
                  const cls = classnames({
                    "cell-descript": true,
                    even: description.index % 2 === 0,
                    // enheght26: description.index === "26",
                    // enheght28: description.index === "28",
                    enheght18: description.index === "18",
                  });
                  return <div className={cls}>{description.descript}</div>;
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export const BuildIdaasTableHead = () => {
  const { t } = useTranslation();
  return (
    <div className="table-head-warp">
      <div className="first-head">
        {t("solution.buildIdaas.list.table.firstHead")}
      </div>
      <div className="second-head">
        {t("solution.buildIdaas.list.table.secondHead")}
      </div>
      <div className="third-head">
        {t("solution.buildIdaas.list.table.thirdHead")}
      </div>
    </div>
  );
};
export const BuildIdaasFeaturesTable = () => {
  const { t } = useTranslation();
  const tableData = [
    {
      title: `${t("solution.buildIdaas.list.table.item1.title")}`,
      contents: [
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item1.content.subtitle1"
          )}`,
          descriptions: [
            {
              index: "1",
              descript: `${t(
                "solution.buildIdaas.list.table.item1.content.descriptions1.description1"
              )}`,
            },
            {
              index: "2",
              descript: `${t(
                "solution.buildIdaas.list.table.item1.content.descriptions1.description2"
              )}`,
            },
            {
              index: "3",
              descript: `${t(
                "solution.buildIdaas.list.table.item1.content.descriptions1.description3"
              )}`,
            },
            {
              index: "4",
              descript: `${t(
                "solution.buildIdaas.list.table.item1.content.descriptions1.description4"
              )}`,
            },
            {
              index: "5",
              descript: `${t(
                "solution.buildIdaas.list.table.item1.content.descriptions1.description5"
              )}`,
            },
          ],
        },
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item1.content.subtitle2"
          )}`,
          descriptions: [
            {
              index: "6",
              descript: `${t(
                "solution.buildIdaas.list.table.item1.content.descriptions2.description1"
              )}`,
            },
            {
              index: "7",
              descript: `${t(
                "solution.buildIdaas.list.table.item1.content.descriptions2.description2"
              )}`,
            },
          ],
        },
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item1.content.subtitle3"
          )}`,
          descriptions: [
            {
              index: "8",
              descript: `${t(
                "solution.buildIdaas.list.table.item1.content.descriptions3.description1"
              )}`,
            },
            {
              index: "9",
              descript: `${t(
                "solution.buildIdaas.list.table.item1.content.descriptions3.description2"
              )}`,
            },
          ],
        },
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item1.content.subtitle4"
          )}`,
          descriptions: [
            {
              index: "10",
              descript: `${t(
                "solution.buildIdaas.list.table.item1.content.descriptions4.description1"
              )}`,
            },
          ],
        },
      ],
    },
    {
      title: `${t("solution.buildIdaas.list.table.item2.title")}`,
      contents: [
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item2.content.subtitle1"
          )}`,
          descriptions: [
            {
              index: "11",
              descript: `${t(
                "solution.buildIdaas.list.table.item2.content.descriptions1.description1"
              )}`,
            },
          ],
        },
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item2.content.subtitle2"
          )}`,
          descriptions: [
            {
              index: "12",
              descript: `${t(
                "solution.buildIdaas.list.table.item2.content.descriptions2.description1"
              )}`,
            },
          ],
        },
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item2.content.subtitle3"
          )}`,
          descriptions: [
            {
              index: "13",
              descript: `${t(
                "solution.buildIdaas.list.table.item2.content.descriptions3.description1"
              )}`,
            },
          ],
        },
      ],
    },
    {
      title: `${t("solution.buildIdaas.list.table.item3.title")}`,
      contents: [
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item3.content.subtitle1"
          )}`,
          descriptions: [
            {
              index: "14",
              descript: `${t(
                "solution.buildIdaas.list.table.item3.content.descriptions1.description1"
              )}`,
            },
          ],
        },
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item3.content.subtitle2"
          )}`,
          descriptions: [
            {
              index: "15",
              descript: `${t(
                "solution.buildIdaas.list.table.item3.content.descriptions2.description1"
              )}`,
            },
          ],
        },
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item3.content.subtitle3"
          )}`,
          descriptions: [
            {
              index: "16",
              descript: `${t(
                "solution.buildIdaas.list.table.item3.content.descriptions3.description1"
              )}`,
            },
          ],
        },
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item3.content.subtitle4"
          )}`,
          descriptions: [
            {
              index: "17",
              descript: `${t(
                "solution.buildIdaas.list.table.item3.content.descriptions4.description1"
              )}`,
            },
          ],
        },
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item3.content.subtitle5"
          )}`,
          descriptions: [
            {
              index: "18",
              descript: `${t(
                "solution.buildIdaas.list.table.item3.content.descriptions5.description1"
              )}`,
            },
          ],
        },
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item3.content.subtitle6"
          )}`,
          descriptions: [
            {
              index: "19",
              descript: `${t(
                "solution.buildIdaas.list.table.item3.content.descriptions6.description1"
              )}`,
            },
          ],
        },
      ],
    },
    {
      title: `${t("solution.buildIdaas.list.table.item4.title")}`,
      contents: [
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item4.content.subtitle1"
          )}`,
          descriptions: [
            {
              index: "20",
              descript: `${t(
                "solution.buildIdaas.list.table.item4.content.descriptions1.description1"
              )}`,
            },
          ],
        },
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item4.content.subtitle2"
          )}`,
          descriptions: [
            {
              index: "21",
              descript: `${t(
                "solution.buildIdaas.list.table.item4.content.descriptions2.description1"
              )}`,
            },
          ],
        },
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item4.content.subtitle3"
          )}`,
          descriptions: [
            {
              index: "22",
              descript: `${t(
                "solution.buildIdaas.list.table.item4.content.descriptions3.description1"
              )}`,
            },
          ],
        },
      ],
    },
    {
      title: `${t("solution.buildIdaas.list.table.item5.title")}`,
      contents: [
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item5.content.subtitle1"
          )}`,
          descriptions: [
            {
              index: "23",
              descript: `${t(
                "solution.buildIdaas.list.table.item5.content.descriptions1.description1"
              )}`,
            },
          ],
        },
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item5.content.subtitle2"
          )}`,
          descriptions: [
            {
              index: "24",
              descript: `${t(
                "solution.buildIdaas.list.table.item5.content.descriptions2.description1"
              )}`,
            },
          ],
        },
      ],
    },
    {
      title: `${t("solution.buildIdaas.list.table.item6.title")}`,
      contents: [
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item6.content.subtitle1"
          )}`,
          descriptions: [
            {
              index: "25",
              descript: `${t(
                "solution.buildIdaas.list.table.item6.content.descriptions1.description1"
              )}`,
            },
          ],
        },
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item6.content.subtitle2"
          )}`,
          descriptions: [
            {
              index: "26",
              descript: `${t(
                "solution.buildIdaas.list.table.item6.content.descriptions2.description1"
              )}`,
            },
          ],
        },
      ],
    },
    {
      title: `${t("solution.buildIdaas.list.table.item8.title")}`,
      contents: [
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item8.content.subtitle1"
          )}`,
          descriptions: [
            {
              index: "27",
              descript: `${t(
                "solution.buildIdaas.list.table.item8.content.descriptions1.description1"
              )}`,
            },
          ],
        },
        {
          subtitle: `${t(
            "solution.buildIdaas.list.table.item8.content.subtitle2"
          )}`,
          descriptions: [
            {
              index: "28",
              descript: `${t(
                "solution.buildIdaas.list.table.item8.content.descriptions2.description1"
              )}`,
            },
          ],
        },
      ],
    },
  ];
  const renderBuildIdaasFeaturesTablePC = () => {
    return (
      <div className="build-idaas-features-table-pc">
        <div className="build-idaas-feature-table-head">
          <BuildIdaasTableHead />
        </div>
        <div className="build-idaas-feature-table-content">
          {tableData.map((item) => (
            <TableCell title={item.title} contents={item.contents} />
          ))}
        </div>
      </div>
    );
  };
  const renderBuildIdaasFeaturesTableMobile = () => {
    return (
      <div className="build-idaas-features-table-mobile">
        <div className="build-idaas-feature-table-content">
          {tableData.map((item) => (
            <TableCell
              title={item.title}
              contents={item.contents}
              isMobile={true}
            />
          ))}
        </div>
      </div>
    );
  };
  return (
    <div className="build-idaas-features-table">
      <section>
        <div className="inner">
          <Title title={t("solution.buildIdaas.list.title")}>
            {t("solution.buildIdaas.list.subtitle")}
          </Title>
          {renderBuildIdaasFeaturesTablePC()}
          {renderBuildIdaasFeaturesTableMobile()}
        </div>
      </section>
    </div>
  );
};
